import script from "./Inpaint.vue?vue&type=script&setup=true&lang=ts"
export * from "./Inpaint.vue?vue&type=script&setup=true&lang=ts"

import "./Inpaint.scss?vue&type=style&index=0&id=b5ee05a8&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b5ee05a8"]])

export default __exports__